<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewSettings.sms_templates.title") }}</h3>
    <v-card class="mt-2" elevation="0" :loading="isLoading">
      <v-flex xs12 lg12>
        <v-row class="pa-0 ma-0">
          <v-col cols="6">
            <v-form ref="SMSTemplateForm">
              <v-text-field
                  outlined
                  v-if="!isLoading || !!this.$route.params.id"
                  :rules="[
              (v) => !!v || $t('form.validationErrors.field_is_required'),
            ]"
                  :value="emptySmsTemplate.name"
                  v-model="emptySmsTemplate.name"
                  :label="$t('common.title')"
                  :disabled="isLoading"
              ></v-text-field>
              <v-select
                  xs6
                  item-text="name"
                  item-value="value"
                  outlined
                  :items="templateTypes"
                  :rules="[
              (v) => !!v || $t('form.validationErrors.field_is_required'),
            ]"
                  :label="$t('common.type')"
                  v-model="emptySmsTemplate.type"
                  :disabled="isLoading"
              >
              </v-select>
              <v-textarea
                  outlined
                  v-model="emptySmsTemplate.text"
                  :label="$t('viewSettings.sms_templates.text')"
                  :rules="[
              (v) => !!v || $t('form.validationErrors.field_is_required'),
            ]"
                  :disabled="isLoading"
                  ref="textarea"
              ></v-textarea>
            </v-form>
            <v-row ma-0>
              <v-col cols="9" class="pb-0 pr-0">
                <v-form ref="test">
                  <v-text-field
                      dense
                      placeholder="79991111111"
                      :placeholder="$t('viewSettings.sms_templates.phone_placeholder')"
                      outlined
                      v-if="!isLoading || !!this.$route.params.id"
                      :rules="[
                  (v) => !!v || $t('form.validationErrors.field_is_required'),
                  (v) => (v && v.length>10) ||$t('form.validationErrors.minLength', [10])
                ]"
                      :value="emptySmsTemplate.phone"
                      v-model="emptySmsTemplate.phone"
                      :label="$t('common.phone')"
                      :disabled="isLoading"
                  ></v-text-field>
                </v-form>
              </v-col>
              <v-col cols="3" class="pb-5 pr-0">
                <v-btn
                    :disabled="isLoading"
                    :loading="isLoading"
                    elevation="0"
                    color="success"
                    @click="test"
                    @keyup.enter="test"
                >
                  {{ $t("viewSettings.sms_templates.test") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <div v-if="isLoadingSmsTemplatePlaceholders" class="text-center">
              <v-progress-circular
                  size="64"
                  indeterminate
                  color="primary"
                  className="mx-auto d-block"
              ></v-progress-circular>
            </div>
            <div v-else>
              <v-list-item-group

              >
                <v-list-item
                    v-for="placeholder in placeholders"
                    :key="placeholder.id"
                    @click="addPlaceholder(placeholder.value)"
                    active-class="v-list-item--active"
                    :class="chipColor(placeholder.value) ? 'v-list-item--active' : ''"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                         {{ $t("viewSettings.sms_templates.placeholders."+placeholder.value) }}
                        </span>
                      </template>
                      {{ $t("viewSettings.sms_templates.placeholders."+placeholder.value) }}
                    </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </div>
          </v-col>
        </v-row>
      </v-flex>
      <v-flex xs12 lg12>
        <v-divider></v-divider>
        <v-spacer></v-spacer>
        <v-btn
            :disabled="isLoading"
            :loading="isLoading"
            class="mt-5 white--text mr-4"
            elevation="0"
            color="red"
            @click="$router.push({ name: 'settings-sms-templates' })"
            @keyup.enter="$router.push({ name: 'settings-sms-templates' })"
        >
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn
            :disabled="isLoading"
            :loading="isLoading"
            class="mt-5"
            elevation="0"
            color="primary"
            @click="submit"
            @keyup.enter="submit"
        >
          {{ $t("common.save") }}
        </v-btn>
      </v-flex>
    </v-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  data: () => ({
    emptySmsTemplate: {
      name: null,
      text: null,
      type: null,
      phone: null,
    },
  }),
  created() {
    this.onLoad();
  },

  watch: {
    $route(to, from) {
      this.onLoad();
    },
  },
  computed: {
    ...mapFields("sms_templates", ["isLoading", "smsTemplates", "smsTemplatePlaceholders"]),
    ...mapFields('sms_templates_placeholders', ['isLoadingSmsTemplatePlaceholders', 'placeholders']),
    templateTypes() {
      return [
        {
          name: this.$t("viewSettings.sms_templates.personal"),
          value: "personal",
        },
        {
          name: this.$t("viewSettings.sms_templates.mass"),
          value: "mass",
        },
      ];
    },
    selectedPlaceholders(){
      let result = [];
      if(this.placeholders && this.placeholders.length && this.emptySmsTemplate.text && this.emptySmsTemplate.text.length) {
        for (let i in this.placeholders) {
          let placeholder = this.placeholders[i]
          if (this.emptySmsTemplate.text.includes(`#${placeholder.value}#`)) {
            result.push(placeholder.value)
          }
        }
      }
      return result;
    }
  },
  methods: {
    chipColor(value){
      return this.selectedPlaceholders.includes(value) ? 'primary' : undefined;
    },
    addPlaceholder(insertText){
      insertText = ` #${insertText}#`
      if (!insertText.length) return

      const textarea = this.$refs.textarea.$refs.input
      const sentence = textarea.value
      const len = sentence.length
      let pos = textarea.selectionStart
      if (pos === undefined) {
        pos = 0
      }

      const before = sentence.substr(0, pos)
      const after = sentence.substr(pos, len)

      this.emptySmsTemplate.text = before + insertText + after

      this.$nextTick().then(() => {
        textarea.selectionStart = pos + insertText.length
      })
    },
    onLoad() {
      this.$store.dispatch("sms_templates_placeholders/get");

      if (this.$route.params.id > 0) {
        this.$store.dispatch("sms_templates/get").then(() => {
          if (
            !this.smsTemplates.filter(
              (item) => Number(item.id) === Number(this.$route.params.id)
            )
          ) {
            this.$router.push({ name: "404" });
          } else {
            let tmpl = this.smsTemplates.find(
              (item) => Number(item.id) === Number(this.$route.params.id)
            );
            this.emptySmsTemplate = JSON.parse(JSON.stringify(tmpl));
            this.$refs["test"].reset()
          }
        });
      }
    },
    submit() {
      if (this.$refs["SMSTemplateForm"].validate()) {
        if (this.$route.params.id > 0) {
          this.$store
            .dispatch("sms_templates/update", this.emptySmsTemplate)
            .then((id) => {
              if (id > 0) {
                this.$router.push({ name: "settings-sms-templates" });
              }
            });
        } else {
          this.$store
            .dispatch("sms_templates/store", this.emptySmsTemplate)
            .then((id) => {
              if (id > 0) {
                this.$router.push({
                  name: "settings-sms-template-edit",
                  params: { id: id },
                });
              }
            });
        }
      }
    },
    test() {
      if (this.$refs["test"].validate()) {
          this.$store.dispatch("sms_templates/test", this.emptySmsTemplate);
      }
    },
  },
};
</script>
